import { AlertProps, AlertTypes } from "./types"
import { debug } from "~utils"
import {
  resolveAlertMessage,
  resolveAlertOnClose,
  showErrorToast,
  showSuccessToast,
  showWarningToast,
  type AlertLikeInput,
} from "~utils/toast-notify"

export const alertSuccess = (input: AlertProps | AlertLikeInput): void => {
  const message = resolveAlertMessage(input, "操作成功")
  debug(`[ALERT][${AlertTypes.SUCCESS}]: `, message)
  showSuccessToast(message, resolveAlertOnClose(input))
}

export const alertError = (input: AlertProps | AlertLikeInput | Error): void => {
  const message = resolveAlertMessage(input, "操作失败")
  debug(`[ALERT][${AlertTypes.ERROR}]: `, message)
  showErrorToast(message, resolveAlertOnClose(input))
}

export const alertWarning = (input: AlertProps | AlertLikeInput): void => {
  const message = resolveAlertMessage(input, "请注意")
  debug(`[ALERT][${AlertTypes.WARNING}]: `, message)
  showWarningToast(message, resolveAlertOnClose(input))
}
